var p = $(".js-ellipsis-overflow");
$.each(p, function(i, val) {
	if (val.scrollHeight > val.offsetHeight) {
		var arrow = $(this).next('.has-overflow').show();
	}
}); 
